export interface Remarks {
  pnrCode: string;
  remark: RemarkType[];
  country: string;
  officeId: string;
  gds: string;
  bookingCode: string;
  transactionId: string;
}

export interface RemarkType {
  text: string;
  remarkType: Types;
}

export enum Types {
  GENERIC = 'generic',
  HISTORIC = 'historic',
}
